// ToolbarActions — shared primitive for list/table page header action rows.
import { type CSSProperties, type ReactNode } from 'react';

export interface ToolbarActionsProps {
  children: ReactNode;
  style?: CSSProperties;
}

/**
 * @aiPurpose Wrap a list/table page header's action controls (search, filter,
 * create, toggle buttons) so they wrap onto new rows on narrow viewports
 * instead of overflowing off-screen.
 *
 * CONVENTION: every list/table page header MUST place its action controls
 * inside <ToolbarActions>. New table pages do the same.
 */
export function ToolbarActions({ children, style }: ToolbarActionsProps) {
  const base: CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
  };
  return <div style={{ ...base, ...style }}>{children}</div>;
}
